import { render, staticRenderFns } from "./tcdtMore.vue?vue&type=template&id=ee980aa6&scoped=true&"
import script from "./tcdtMore.vue?vue&type=script&lang=js&"
export * from "./tcdtMore.vue?vue&type=script&lang=js&"
import style0 from "./tcdtMore.vue?vue&type=style&index=0&id=ee980aa6&lang=less&scoped=true&"
import style1 from "./tcdtMore.vue?vue&type=style&index=1&id=ee980aa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee980aa6",
  null
  
)

export default component.exports